import { Component, Input } from '@angular/core';

/**
 * Loader modal shown while a cancellation is in flight.
 *
 * The `usb-popup` overlay is bound to `[showAlways]="true"` (not
 * `[isLoading]="isLoading"`) because this component never flips
 * `isLoading` to true. With the previous binding, the overlay stayed
 * `opacity: 0 / visibility: hidden` and the modal opened as a blank
 * card. Mirrors the convention used by `ReservingModalComponent`,
 * which also uses `[showAlways]="true"` for the same reason.
 */
@Component({
  selector: 'usb-cancel-modal',
  template: `
    <usb-popup [showAlways]="true">
      <div class="mb-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="55" fill="currentColor" class="bi bi-ban cancel-loader_icon" viewBox="0 0 16 16">
          <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71,12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>
        </svg>
      </div>
      <h2 class="cancel-loader_title">Cancelando</h2>
      <h3 class="cancel-loader_subtitle mb-2">Producto</h3>
      <p class="cancel-loader_text">Procesando la cancelación de productos...</p>
    </usb-popup>
  `,
  styleUrls: ['./cancel-modal.component.scss']
})
export class CancelModalComponent {
  @Input() isLoading = false;
}
